import moment from "moment";
import { reportG8 } from "./../services/reportG8.service";
import { Operator_service } from "../services/Operator_service";
import { Typegroup_service } from "../services/Typegroup.service";
import { MessageBox, Loading } from "element-ui";
const month_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
const month_th_abbreviation = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย", "พ.ค.", "มิ.ย.","ก.ค.", "ส.ค", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
const state = {
  provider_group: [],
  provider_list: [],
  prototype: {
      chart: {
          type: 'spline'
      },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      xAxis: {
          categories: [],
          crosshair: true
      },
      yAxis: {
          min: 0,
          title: {
              text: 'อัตราค่าบริการ (บาท/นาที)'
          }
      },
      tooltip: {
          // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          //     '<td style="padding:0"><b>{point.y.toFixed(2)}</b></td></tr>',
          // footerFormat: '</table>',
          shared: false,
          useHTML: true,
          valueDecimals: 2,
      },
      plotOptions: {
          spline: {
              pointPadding: 0.2,
              borderWidth: 0,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels:{
                enabled: true,
                format: '{point.y:.2f}',
                allowOverlap: true,
                overflow: "allow",
                crop: false
              },
              showInLegend: true,
              animation: {
                duration: 2000
            }
          }
      },
      series: [],
      exporting: {
        buttons: {
          contextButton:{
              menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
          }
        }
      },
      credits: {
        enabled: false
      }
  },
  charts: {},
  datasets:[],
  options: {},
  main_proportion: 0,
  ontop_proportion: 0,
  chartResult: true,
}
const actions = {
  async getGroupCompany({commit},type){
    let obj = { provider_type : type}
    let result = await Typegroup_service.getGroupList(obj)
    if(result.status == 200){
      commit('PROVIDER_GROUP',result.data)
    }else {
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
      })
    }
  },
  async getProviderByType({commit},type){
  let result = await Operator_service.getProviderList(type)
  if(result.status == 200){
      commit('PROVIDER_LIST',result.data)
  }else {
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
      })
  }
  },
  async setReportData({commit},formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let result = await reportG8.getDataReport(formdata)
    let fixResult = await reportG8.getFixDataReport(formdata)
    let serviceProp = await reportG8.getServiceProp()
    let forecast = await reportG8.getForecast(formdata)
    if(result.status == 200 && fixResult.status == 200 && serviceProp.status == 200){
      if(result.data.length == '' && fixResult.data.length == ''){
        setTimeout(function(){ loadingInstance.close() }, 250);
        state.chartResult = false
      } else {
        state.main_proportion = serviceProp.data[0].proportion_main_promotion
        state.ontop_proportion = serviceProp.data[0].proportion_ontop_promotion
        let obj = null
        switch (formdata.type_report){
          case 'between_month':
            obj = {
              forminfo: formdata,
              qrydata: result.data,
              fixdata: fixResult.data,
              proportion: serviceProp.data[0],
              forecast: forecast.data,
              date: {
                start: moment(formdata.type_data.monthfrom).format('YYYY-MM-DD'),
                end: moment(formdata.type_data.monthto).add(1, 'M').subtract(1,'d').format('YYYY-MM-DD')
              }
            }
            commit('BETWEEN_MONTH',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break
          case 'year':
            obj = {
              forminfo: formdata,
              qrydata: result.data,
              fixdata: fixResult.data,
              proportion: serviceProp.data[0],
              forecast: forecast.data,
              date: {
                start: moment(formdata.type_data.year).format('YYYY-MM-DD'),
                end: moment(formdata.type_data.year).add(1, 'Y').subtract(1,'d').format('YYYY-MM-DD')
              }
            }
            commit('YEAR',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break
          case 'between_year':
            obj = {
              forminfo: formdata,
              qrydata: result.data,
              fixdata: fixResult.data,
              proportion: serviceProp.data[0],
              forecast: forecast.data,
              date: {
                start: moment(formdata.type_data.yearfrom).format('YYYY-MM-DD'),
                end: moment(formdata.type_data.yearto).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD')
              }
            }
            commit('YEAR',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break
          case 'quarter':
            obj = {
              forminfo: formdata,
              qrydata: result.data,
              fixdata: fixResult.data,
              proportion: serviceProp.data[0],
              forecast: forecast.data,
              date: {
                start: moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter - 1) * 3,'M').format('YYYY-MM-DD'),
                end: moment(formdata.type_data.quarter_year).add(formdata.type_data.quarter * 3,'M').subtract(1, 'd').format('YYYY-MM-DD')
              }
            }
            commit('QUARTER', obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break
          case 'between_quarter':
            obj = {
              forminfo: formdata,
              qrydata: result.data,
              fixdata: fixResult.data,
              proportion: serviceProp.data[0],
              forecast: forecast.data,
              date: {
                start: moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom - 1) * 3,'M').format('YYYY-MM-DD'),
                end: moment(formdata.type_data.quarter_year).add(formdata.type_data.quarterto * 3,'M').subtract(1, 'd').format('YYYY-MM-DD')
              }
            }
            commit('QUARTER',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break
        }
      }
    } else {
      setTimeout(function(){ loadingInstance.close() }, 250);
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
      })
    }
  },
};

const mutations = {
  PROVIDER_GROUP(state,data){
    state.provider_group = data
  },
  PROVIDER_LIST(state,data){
    state.provider_list = data
  },
  BETWEEN_MONTH(state, data){
    let month_start = month_th[moment(data.date.start).month()]+" ปี พ.ศ. "+moment(data.date.start).add(543,'Y').year()
    let month_end = month_th[moment(data.date.end).month()]+" ปี พ.ศ. "+moment(data.date.end).add(543,'Y').year()
    let proportion = data.proportion
    let total = {
      minute_avg: 0,
      second_avg: 0
    }
    let providers = data.forminfo.list
    let provider_name = data.forminfo.type_providers == 'group' ? providers[0].group_name_th : providers[0].brand_name
    let categories = []
    let minute_result = []
    let second_result = []
    let avg_result = []
    let chart = JSON.parse(JSON.stringify(state.prototype))

    chart.title.text = `แนวโน้มของอัตราค่าบริการโปรวินาทีและโปรนาทีของผู้ให้บริการ ${provider_name} ระหว่างเดือน${month_start} ถึงเดือน${month_end}`

    for(let date = moment(data.date.start)._d; date < moment(data.date.end)._d ; date = moment(date).add(1,'M')){
      let month = moment(date).month();
      let year = moment(date).year();
      let year_th = (''+(year + 543)).slice(-2)
      let curmonth = moment(date).format('YYYY-MM-DD');
      let minute = {
        main_sum: 0,
        ontop_sum: 0,
        main_amount: 0,
        ontop_amount: 0
      }
      let second = {
        main_sum: 0,
        ontop_sum: 0,
        main_amount: 0,
        ontop_amount: 0
      }
      
      if (year < 2020) {
        let fixdata = data.fixdata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
        for (let i = 0; i < fixdata.length; i++) {
          total.minute_avg = fixdata[i].minute_average
          total.second_avg = fixdata[i].second_average
        }
      } else {
        let monthly_data = data.qrydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
        for (let i = 0; i < monthly_data.length; i++) {
          if (monthly_data[i].service_charge_type.toLowerCase() == 'minute') {
            if (monthly_data[i].promotion_type == 'main') {
              minute.main_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
              minute.main_amount++;
            } else {
              minute.ontop_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
              minute.ontop_amount++;
            }
          } else {
            if (monthly_data[i].promotion_type == 'main') {
              second.main_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
              second.main_amount++;
            } else {
              second.ontop_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
              second.ontop_amount++;
            }
          }
        }
        console.log('minute:', minute)
        console.log('second:', second)
        if (minute.ontop_amount != 0) {
          total.minute_avg = ((minute.main_sum / minute.main_amount) * (proportion.proportion_main_promotion / 100)) + ((minute.ontop_sum / minute.main_amount) * (proportion.proportion_ontop_promotion / 100))
        } else {
          total.minute_avg = (minute.main_sum / minute.main_amount)
        }
        if (second.ontop_amount != 0) {
          total.second_avg = ((second.main_sum / second.main_amount) * (proportion.proportion_main_promotion / 100)) + ((second.ontop_sum / second.main_amount) * (proportion.proportion_ontop_promotion / 100))
        } else {
          total.second_avg = (second.main_sum / second.main_amount)
        }
      }
      minute_result.push({ y: !isNaN(total.minute_avg) && total.minute_avg != 0 ? total.minute_avg : null, dataLabels: {verticalAlign: total.minute_avg <= total.second_avg ? 'top' : 'bottom'}})
      second_result.push({ y: !isNaN(total.second_avg) && total.second_avg != 0 ? total.second_avg : null, dataLabels: {verticalAlign: total.minute_avg <= total.second_avg ? 'bottom' : 'top'}})
      let avg = (total.minute_avg + total.second_avg)/2
      avg_result.push({ y: !isNaN(avg) && avg != 0 ? avg : null, dataLabels: {verticalAlign: 'middle'}})
      categories.push(`${month_th_abbreviation[month]}-${year_th}`)
    }
    if (data.forminfo.forecast) {
      minute_result.push({ y: data.forecast.minute, dataLabels: {verticalAlign: data.forecast.minute <= data.forecast.second ? 'top' : 'bottom'}})
      second_result.push({ y: data.forecast.second, dataLabels: {verticalAlign: data.forecast.minute <= data.forecast.second ? 'bottom' : 'top'}})
      let temp_avg = (data.forecast.minute + data.forecast.second) / 2
      avg_result.push({ y: temp_avg, dataLabels: {verticalAlign: 'middle'}})
      categories.push('แนวโน้ม')
    }
    chart.xAxis.categories = categories
    chart.series.push({
      name: 'โปรนาที',
      data: minute_result,
      color: '#ff4d4d'
    })
    chart.series.push({
      name: 'โปรวินาที',
      data: second_result,
      color: '#3333ff'
    })
    if (data.forminfo.graphAvg) {
      chart.series.push({
        name: 'อัตราค่าบริการเฉลี่ย',
        data: avg_result,
        color: 'rgb(0, 204, 0)'
      })
    }
    chart.tooltip.formatter = function () {
      return '<span style="font-size:10px">' + this.point.category + '</span><table><tr><td style="color:' + this.point.color +';padding:0">•</td><td padding:0">' + this.series.name + ': </td>' +
           '<td style="padding:0"><b>' + this.point.y.toFixed(2) + '</b></td></tr></table>'
    },
    state.chartResult = true
    state.charts = chart
  },
  YEAR(state,data){
    let year = ' ปี พ.ศ. ' + moment(data.date.start).add(543,'Y').year()
    let yearto = ' ถึงปี พ.ศ. ' + moment(data.date.end).add(543,'Y').year()
    let proportion = data.proportion
    let total = {
      minute_avg: 0,
      second_avg: 0
    }
    let providers = data.forminfo.list
    let provider_name = data.forminfo.type_providers == 'group' ? providers[0].group_name_th : providers[0].brand_name
    let categories = []
    let minute_result = []
    let second_result = []
    let avg_result = []
    let chart = JSON.parse(JSON.stringify(state.prototype))
    if (data.forminfo.type_report == 'year') {
      chart.title.text = `แนวโน้มของอัตราค่าบริการโปรวินาทีและโปรนาทีของผู้ให้บริการ ${provider_name}${year}`
    } else {
      chart.title.text = `แนวโน้มของอัตราค่าบริการโปรวินาทีและโปรนาทีของผู้ให้บริการ ${provider_name}${year}${yearto}`
    }
    
    for(let date_year = moment(data.date.start)._d; date_year < moment(data.date.end)._d; date_year =  moment(date_year).add(1, 'Y')._d) {
      let minute_sum = 0
      let second_sum = 0
      let minute_amount = 0
      let second_amount = 0
      let year_th = (''+(moment(date_year).add(543, 'Y').year())).slice(-2)
      for(let date = moment(date_year)._d; date < moment(date_year).add(1, 'Y').subtract(1, 'd')._d ; date = moment(date).add(1,'M')){
        let year = moment(date).year();
        let curmonth = moment(date).format('YYYY-MM-DD');
        let minute = {
          main_sum: 0,
          ontop_sum: 0,
          main_amount: 0,
          ontop_amount: 0
        }
        let second = {
          main_sum: 0,
          ontop_sum: 0,
          main_amount: 0,
          ontop_amount: 0
        }
        
        if (year < 2020) {
          let fixdata = data.fixdata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
          for (let i = 0; i < fixdata.length; i++) {
            total.minute_avg = fixdata[i].minute_average
            total.second_avg = fixdata[i].second_average
          }
        } else {
          let monthly_data = data.qrydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
          for (let i = 0; i < monthly_data.length; i++) {
            if (monthly_data[i].service_charge_type.toLowerCase() == 'minute') {
              if (monthly_data[i].promotion_type == 'main') {
                minute.main_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                minute.main_amount++;
              } else {
                minute.ontop_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                minute.ontop_amount++;
              }
            } else {
              if (monthly_data[i].promotion_type == 'main') {
                second.main_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                second.main_amount++;
              } else {
                second.ontop_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                second.ontop_amount++;
              }
            }
          }
          if (minute.ontop_amount != 0) {
            total.minute_avg = ((minute.main_sum / minute.main_amount) * (proportion.proportion_main_promotion / 100)) + ((minute.ontop_sum / minute.main_amount) * (proportion.proportion_ontop_promotion / 100))
          } else {
            total.minute_avg = (minute.main_sum / minute.main_amount)
          }
          if (second.ontop_amount != 0) {
            total.second_avg = ((second.main_sum / second.main_amount) * (proportion.proportion_main_promotion / 100)) + ((second.ontop_sum / second.main_amount) * (proportion.proportion_ontop_promotion / 100))
          } else {
            total.second_avg = (second.main_sum / second.main_amount)
          }
        }
        if (!isNaN(total.minute_avg)) {
          minute_sum += total.minute_avg
          minute_amount++
        }
        if (!isNaN(total.second_avg)) {
          second_sum += total.second_avg
          second_amount++
        }
      }
      let min_avg = minute_sum/minute_amount
      let sec_avg = second_sum/second_amount
      let total_avg = (min_avg + sec_avg) / 2
      minute_result.push({ y: !isNaN(min_avg) && min_avg != 0 ? min_avg : null, dataLabels: {verticalAlign: min_avg <= sec_avg ? 'top' : 'bottom'}})
      second_result.push({ y: !isNaN(sec_avg) && sec_avg != 0 ? sec_avg : null, dataLabels: {verticalAlign: min_avg <= sec_avg ? 'bottom' : 'top'}})
      avg_result.push({ y: !isNaN(total_avg) && total_avg != 0 ? total_avg : null, dataLabels: {verticalAlign: 'middle'}})
      categories.push(`พ.ศ.${year_th}`)
    }
    if (data.forminfo.forecast) {
      minute_result.push({ y: data.forecast.minute, dataLabels: {verticalAlign: data.forecast.minute <= data.forecast.second ? 'top' : 'bottom'}})
      second_result.push({ y: data.forecast.second, dataLabels: {verticalAlign: data.forecast.minute <= data.forecast.second ? 'bottom' : 'top'}})
      let temp_avg = (data.forecast.minute + data.forecast.second) / 2
      avg_result.push({ y: temp_avg, dataLabels: {verticalAlign: 'middle'}})
      categories.push('แนวโน้ม')
    }
    chart.xAxis.categories = categories
    chart.series.push({
      name: 'โปรนาที',
      data: minute_result,
      color: '#ff4d4d'
    })
    chart.series.push({
      name: 'โปรวินาที',
      data: second_result,
      color: '#3333ff'
    })
    if (data.forminfo.graphAvg) {
      chart.series.push({
        name: 'อัตราค่าบริการเฉลี่ย',
        data: avg_result,
        color: 'rgb(0, 204, 0)'
      })
    }
    chart.tooltip.formatter = function () {
      return '<span style="font-size:10px">' + this.point.category + '</span><table><tr><td style="color:' + this.point.color +';padding:0">•</td><td padding:0">' + this.series.name + ': </td>' +
           '<td style="padding:0"><b>' + this.point.y.toFixed(2) + '</b></td></tr></table>'
    },
    state.chartResult = true
    state.charts = chart
  },
  QUARTER(state,data){
    let start = 'ในไตรมาสที่ ' + moment(data.date.start).quarter() + ' ปี พ.ศ. ' + moment(data.date.start).add(543,'Y').year()
    let end = ' ถึงไตรมาสที่ ' + moment(data.date.end).quarter() + ' ปี พ.ศ. ' + moment(data.date.end).add(543,'Y').year()
    let proportion = data.proportion
    let total = {
      minute_avg: 0,
      second_avg: 0
    }
    let providers = data.forminfo.list
    let provider_name = data.forminfo.type_providers == 'group' ? providers[0].group_name_th : providers[0].brand_name
    let categories = []
    let minute_result = []
    let second_result = []
    let avg_result = []
    let chart = JSON.parse(JSON.stringify(state.prototype))
    if (data.forminfo.type_report == 'quarter') {
      chart.title.text = `แนวโน้มของอัตราค่าบริการโปรวินาทีและโปรนาทีของผู้ให้บริการ ${provider_name}${start}`
    } else {
      chart.title.text = `แนวโน้มของอัตราค่าบริการโปรวินาทีและโปรนาทีของผู้ให้บริการ ${provider_name}${start}${end}`
    }
    for(let date_quarter = moment(data.date.start)._d; date_quarter < moment(data.date.end)._d; date_quarter =  moment(date_quarter).add(3, 'M')._d) {
      let minute_sum = 0
      let second_sum = 0
      let minute_amount = 0
      let second_amount = 0
      let quarter_year_th = moment(date_quarter).quarter() + 'Q' + moment(date_quarter).add(543, 'Y').year()
      for(let date = moment(date_quarter)._d; date < moment(date_quarter).add(3, 'M').subtract(1, 'd')._d ; date = moment(date).add(1,'M')){
        let year = moment(date).year();
        let curmonth = moment(date).format('YYYY-MM-DD');
        let minute = {
          main_sum: 0,
          ontop_sum: 0,
          main_amount: 0,
          ontop_amount: 0
        }
        let second = {
          main_sum: 0,
          ontop_sum: 0,
          main_amount: 0,
          ontop_amount: 0
        }
        
        if (year < 2020) {
          let fixdata = data.fixdata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
          for (let i = 0; i < fixdata.length; i++) {
            total.minute_avg = fixdata[i].minute_average ? fixdata[i].minute_average : null
            total.second_avg = fixdata[i].second_average ? fixdata[i].second_average : null
          }
        } else {
          let monthly_data = data.qrydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
          for (let i = 0; i < monthly_data.length; i++) {
            if (monthly_data[i].service_charge_type.toLowerCase() == 'minute') {
              if (monthly_data[i].promotion_type == 'main') {
                minute.main_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                minute.main_amount++;
              } else {
                minute.ontop_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                minute.ontop_amount++;
              }
            } else {
              if (monthly_data[i].promotion_type == 'main') {
                second.main_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                second.main_amount++;
              } else {
                second.ontop_sum += monthly_data[i].voice_per_minute != null ? monthly_data[i].voice_per_minute : monthly_data[i].voice_per_second * 60;
                second.ontop_amount++;
              }
            }
          }
          if (minute.ontop_amount != 0) {
            total.minute_avg = ((minute.main_sum / minute.main_amount) * (proportion.proportion_main_promotion / 100)) + ((minute.ontop_sum / minute.main_amount) * (proportion.proportion_ontop_promotion / 100))
          } else {
            total.minute_avg = (minute.main_sum / minute.main_amount)
          }
          if (second.ontop_amount != 0) {
            total.second_avg = ((second.main_sum / second.main_amount) * (proportion.proportion_main_promotion / 100)) + ((second.ontop_sum / second.main_amount) * (proportion.proportion_ontop_promotion / 100))
          } else {
            total.second_avg = (second.main_sum / second.main_amount)
          }
        }
        if (!isNaN(total.minute_avg)) {
          minute_sum += total.minute_avg
          minute_amount++
        }
        if (!isNaN(total.second_avg)) {
          second_sum += total.second_avg
          second_amount++
        }
      }
      let min_avg = minute_sum/minute_amount
      let sec_avg = second_sum/second_amount
      let total_avg = (min_avg + sec_avg) / 2
      minute_result.push({ y: !isNaN(min_avg) && min_avg != 0 ? min_avg : null, dataLabels: {verticalAlign: min_avg <= sec_avg ? 'top' : 'bottom'}})
      second_result.push({ y: !isNaN(sec_avg) && sec_avg != 0 ? sec_avg : null, dataLabels: {verticalAlign: min_avg <= sec_avg ? 'bottom' : 'top'}})
      avg_result.push({ y: !isNaN(total_avg) && total_avg != 0 ? total_avg : null, dataLabels: {verticalAlign: 'middle'}})
      categories.push(quarter_year_th)
    }
    if (data.forminfo.forecast) {
      minute_result.push({ y: data.forecast.minute, dataLabels: {verticalAlign: data.forecast.minute <= data.forecast.second ? 'top' : 'bottom'}})
      second_result.push({ y: data.forecast.second, dataLabels: {verticalAlign: data.forecast.minute <= data.forecast.second ? 'bottom' : 'top'}})
      let temp_avg = (data.forecast.minute + data.forecast.second) / 2
      avg_result.push({ y: temp_avg, dataLabels: {verticalAlign: 'middle'}})
      categories.push('แนวโน้ม')
    }
    chart.xAxis.categories = categories
    chart.series.push({
      name: 'โปรนาที',
      data: minute_result,
      color: '#ff4d4d'
    })
    chart.series.push({
      name: 'โปรวินาที',
      data: second_result,
      color: '#3333ff'
    })
    if (data.forminfo.graphAvg) {
      chart.series.push({
        name: 'อัตราค่าบริการเฉลี่ย',
        data: avg_result,
        color: 'rgb(0, 204, 0)'
      })
    }
    chart.tooltip.formatter = function () {
      return '<span style="font-size:10px">' + this.point.category + '</span><table><tr><td style="color:' + this.point.color +';padding:0">•</td><td padding:0">' + this.series.name + ': </td>' +
           '<td style="padding:0"><b>' + this.point.y.toFixed(2) + '</b></td></tr></table>'
    },
    state.chartResult = true
    state.charts = chart
  }
};

export const Report_TR = {
  namespaced: true,
  state,
  actions,
  mutations
};
